import CountryService from "app/services/CountryService";

export const getCountryText = (countryCode: number | string): string => {
    const id = Number(countryCode);
    return CountryService.isCountrySupported(id) ? CountryService.getCountryById(id).text : "";
};
